const supportsTouch = 'ontouchstart' in window;

export default {
	ignoreAttributes: true, // Don't parse [data=tippy-*]
	arrow: true, // Show arrow
	interactive: true, // Tippy is interactive
	interactiveBorder: 20, // Number of px outside the element still considered "interaction"
	interactiveDebounce: 100, // Check for interactivity every this number of ms
	role: 'menu', // ARIA role
	theme: 'nav', // Tippy theme
	delay: [0, 750], // Hide this number of ms after the mouse has left the interactive area
	maxWidth: '550px',
	animation: 'perspective',
	
	trigger: supportsTouch
		? 'mouseenter focus' // Use Tippy's default behavior on touch devices 
		: 'mouseenter focus click', // Show on pretty much any interaction
	
	// These are useful for debugging so that Tippy doesn't hide
	// trigger: 'click',
	// hideOnClick: false,
};
